import BaseService from "./BaseService";

export default BaseService;
